import { ProjectorView } from "components/materials/presentation/projector/ProjectorView";

export default function Page() {
  return <ProjectorView />;
}
